import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import store from './store/store';
import { createI18n } from 'vue-i18n';
import { createGtm } from '@gtm-support/vue-gtm';
import translations from './translations/translations';
import Toasted from '@hoppscotch/vue-toasted';
import '@hoppscotch/vue-toasted/style.css';
import SmoothReflow from './components/SmoothReflow.vue';
import { createHead, setHeadInjectionHandler } from '@unhead/vue';
import { analyticsAllowed, ccm19Enabled, onConsentChange } from './lib/consent';
import analytics from './analytics';

const app = createApp(App);

const i18n = createI18n({
  locale: 'en',
  messages: translations,
});

app.use(router);
app.use(store);
app.use(i18n);
app.use(Toasted);
const head = createHead();
//app.use(head);
setHeadInjectionHandler(() => head);
app.component('SmoothReflow', SmoothReflow);

app.config.globalProperties.$filters = {
  truncate(text, stop, clamp) {
    return text.slice(0, stop) + (stop < text.length ? clamp || '...' : '');
  },
};

const scripts = document.getElementsByTagName('script');
const lastScript = scripts[scripts.length - 1];
const publicURL = new URL(lastScript.src);
window.visitate = {};
window.visitate.webshopSrc = `${publicURL.protocol}//${publicURL.host}${import.meta.env.BASE_URL}`;

const trackingAllowed = analyticsAllowed();

if (import.meta.env.VITE_HAS_TAG_MANAGER === 'true') {
  app.use(
    createGtm({
      id: import.meta.env.VITE_TAG_MANAGER_ID, // Your GTM single container ID, array of container ids ['GTM-xxxxxx', 'GTM-yyyyyy'] or array of objects [{id: 'GTM-xxxxxx', queryParams: { gtm_auth: 'abc123', gtm_preview: 'env-4', gtm_cookies_win: 'x'}}, {id: 'GTM-yyyyyy', queryParams: {gtm_auth: 'abc234', gtm_preview: 'env-5', gtm_cookies_win: 'x'}}], // Your GTM single container ID or array of container ids ['GTM-xxxxxx', 'GTM-yyyyyy']
      /*queryParams: {
      // Add url query string when load gtm.js with GTM ID (optional)
      gtm_auth: "AB7cDEf3GHIjkl-MnOP8qr",
      gtm_preview: "env-4",
      gtm_cookies_win: "x",
    },*/
      defer: false, // Script can be set to `defer` to speed up page load at the cost of less accurate results (in case visitor leaves before script is loaded, which is unlikely but possible). Defaults to false, so the script is loaded `async` by default
      compatibility: false, // Will add `async` and `defer` to the script tag to not block requests for old browsers that do not support `async`
      //nonce: "2726c7f26c", // Will add `nonce` to the script tag
      enabled: trackingAllowed, // defaults to true. Plugin can be disabled by setting this to false for Ex: enabled: !!GDPR_Cookie (optional)
      debug: true, // Whether or not display console logs debugs (optional)
      loadScript: true, // Whether or not to load the GTM Script (Helpful if you are including GTM manually, but need the dataLayer functionality in your components) (optional)
      //vueRouter: router, // Pass the router instance to automatically sync with router (optional)
      //ignoredViews: ["homepage"], // Don't trigger events for specified router names (case insensitive) (optional)
      trackOnNextTick: false, // Whether or not call trackView in Vue.nextTick
    })
  );
}
window.visitate.loadFbPixel = function loadFbPixel() {
  !(function (f, b, e, v, n, t, s) {
    if (f.fbq) return;
    n = f.fbq = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
    };
    if (!f._fbq) f._fbq = n;
    n.push = n;
    n.loaded = !0;
    n.version = '2.0';
    n.queue = [];
    t = b.createElement(e);
    t.async = !0;
    t.src = v;
    s = b.getElementsByTagName(e)[0];
    s.parentNode.insertBefore(t, s);
  })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
};

if (import.meta.env.VITE_HAS_FB_PIXEL === 'true' && trackingAllowed) {
  window.visitate.loadFbPixel();
}

window.vue = app.mount('#app');

if (ccm19Enabled() && import.meta.env.VITE_HAS_TAG_MANAGER === 'true') {
  onConsentChange(() => analytics.syncTagManager());
  analytics.syncTagManager();
}

i18n.global.locale = window.vue.$store.state.language;
